import { useState } from "react";
import {
  Box,
  Button,
  ClickAwayListener,
  ListItemIcon,
  MenuItem,
  MenuList,
  Paper,
  Popper,
} from "@mui/material";
import MonthIcon from "@mui/icons-material/CalendarMonth";
import WeekIcon from "@mui/icons-material/DateRange";
import ListIcon from "@mui/icons-material/FormatListBulleted";
import DownIcon from "@mui/icons-material/ArrowDropDown";

export type ViewOption = "LIST" | "MONTHS" | "WEEKS" | "WORKWEEKS";

type ViewSelectButtonProps = {
  view: ViewOption;
  setView: (view: ViewOption) => void;
};

const ViewSelectButton: React.FC<ViewSelectButtonProps> = (props) => {
  const { view, setView } = props;

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleSelect = (view: ViewOption) => {
    setView(view);
    setAnchorEl(null);
  };

  return (
    <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
      <Box component="span" sx={{ ml: "auto" }}>
        <Button
          variant="outlined"
          startIcon={
            view === "LIST" ? <ListIcon /> : view === "MONTHS" ? <MonthIcon /> : <WeekIcon />
          }
          endIcon={<DownIcon />}
          onClick={(e) => setAnchorEl(anchorEl ? null : e.currentTarget)}
          sx={{ "& .MuiButton-endIcon": { ml: 1.5, mr: -1 } }}
        >
          {view === "LIST"
            ? "Lista"
            : view === "MONTHS"
              ? "Månader"
              : view === "WEEKS"
                ? "Veckor"
                : "Arbetsveckor"}
        </Button>

        <Popper open={Boolean(anchorEl)} anchorEl={anchorEl}>
          <Paper>
            <MenuList>
              <MenuItem onClick={() => handleSelect("LIST")}>
                <ListItemIcon>
                  <ListIcon />
                </ListItemIcon>
                Lista
              </MenuItem>
              <MenuItem onClick={() => handleSelect("MONTHS")}>
                <ListItemIcon>
                  <MonthIcon />
                </ListItemIcon>
                Månader
              </MenuItem>
              <MenuItem onClick={() => handleSelect("WEEKS")}>
                <ListItemIcon>
                  <WeekIcon />
                </ListItemIcon>
                Veckor
              </MenuItem>
              <MenuItem onClick={() => handleSelect("WORKWEEKS")}>
                <ListItemIcon>
                  <WeekIcon />
                </ListItemIcon>
                Arbetsveckor
              </MenuItem>
            </MenuList>
          </Paper>
        </Popper>
      </Box>
    </ClickAwayListener>
  );
};

export default ViewSelectButton;
